export { default } from './salaries-modal';
